// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_POSTS_SHOW_MORE = "Viac diskusi\u00ed...";
